export default [
  {
    id: 1,
    name: 'Jhankar Mahbub',
    username: 'Jhankar',
    email: 'jhankar@gmail.com',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439177/hero-user/1_xwzfdv.png',
    address: {
      street: 'Kulas Light',
      suite: 'Apt. 556',
      city: 'Gwenborough',
      zipcode: '92998-3874',
      geo: {
        lat: '-37.3159',
        lng: '81.1496',
      },
    },
    phone: '1-770-736-8031',
    website: 'hildegard.org',
    salary: 1000,
    company: {
      name: 'Romaguera-Crona',
      catchPhrase: 'Multi-layered client-server neural-net',
      bs: 'harness real-time e-markets',
    },
  },
  {
    id: 2,
    name: 'Shuvojit Kar',
    username: 'Antonette',
    email: 'Shanna@melissa.tv',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439172/hero-user/1604765024270_l1pqdl.png',
    address: {
      street: 'Victor Plains',
      suite: 'Suite 879',
      city: 'Wisokyburgh',
      zipcode: '90566-7771',
      geo: {
        lat: '-43.9509',
        lng: '-34.4618',
      },
    },
    phone: '010-692-6593 x09125',
    website: 'anastasia.net',
    salary: 950,
    company: {
      name: 'Deckow-Crist',
      catchPhrase: 'Proactive didactic contingency',
      bs: 'synergize scalable supply-chains',
    },
  },
  {
    id: 3,
    name: 'Rasel Ahmed',
    username: 'Samantha',
    email: 'Nathan@yesenia.net',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614448268/rasel_tbdxnk.png',
    address: {
      street: 'Douglas Extension',
      suite: 'Suite 847',
      city: 'McKenziehaven',
      zipcode: '59590-4157',
      geo: {
        lat: '-68.6102',
        lng: '-47.0653',
      },
    },
    phone: '1-463-123-4447',
    website: 'ramiro.info',
    salary: 780,
    company: {
      name: 'Romaguera-Jacobson',
      catchPhrase: 'Face to face bifurcated interface',
      bs: 'e-enable strategic applications',
    },
  },
  {
    id: 4,
    name: 'Karina Islam',
    username: 'Karianne',
    email: 'Julianne@kory.org',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439172/hero-user/1604765061442_tkcuqq.png',
    address: {
      street: 'Hoeger Mall',
      suite: 'Apt. 692',
      city: 'South Elvis',
      zipcode: '53919-4257',
      geo: {
        lat: '29.4572',
        lng: '-164.2990',
      },
    },
    phone: '493-170-9623',
    website: 'kale.biz',
    salary: 580,
    company: {
      name: 'Robel-Corkery',
      catchPhrase: 'Multi-tiered zero tolerance productivity',
      bs: 'transition cutting-edge web services',
    },
  },
  {
    id: 5,
    name: 'Shajedul Karim',
    username: 'Kamren',
    email: 'Hettinger@annie.ca',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765080815_eucidn.png',
    address: {
      street: 'Skiles Walks',
      suite: 'Suite 351',
      city: 'Roscoeview',
      zipcode: '33263',
      geo: {
        lat: '-31.8129',
        lng: '62.5342',
      },
    },
    phone: '(254)954-1289',
    website: 'demarco.info',
    salary: 895,
    company: {
      name: 'Keebler LLC',
      catchPhrase: 'User-centric fault-tolerant solution',
      bs: 'revolutionize end-to-end systems',
    },
  },
  {
    id: 6,
    name: 'Sufi Ahmed Hamim',
    username: 'Leopoldo_Corkery',
    email: 'Karley@jasper.info',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765099683_slmz9g.png',
    address: {
      street: 'Norberto Crossing',
      suite: 'Apt. 950',
      city: 'South Christy',
      zipcode: '23505-1337',
      geo: {
        lat: '-71.4197',
        lng: '71.7478',
      },
    },
    phone: '1-477-935-8478',
    website: 'ola.org',
    salary: 756,
    company: {
      name: 'Considine-Lockman',
      catchPhrase: 'Synchronised bottom-line interface',
      bs: 'e-enable innovative applications',
    },
  },
  {
    id: 7,
    name: 'Abdur Rakib',
    username: 'Elwyn.Skiles',
    email: 'Hoeger@billy.biz',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765138242_swdr7l.png',
    address: {
      street: 'Rex Trail',
      suite: 'Suite 280',
      city: 'Howemouth',
      zipcode: '58804-1099',
      geo: {
        lat: '24.8918',
        lng: '21.8984',
      },
    },
    phone: '210.067.6132',
    website: 'elvis.io',
    salary: 789,
    company: {
      name: 'Johns Group',
      catchPhrase: 'Configurable multimedia task-force',
      bs: 'generate enterprise e-tailers',
    },
  },
  {
    id: 8,
    name: 'Rezaul Karim',
    username: 'Maxime_Nienow',
    email: 'karim@rosa.me',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765196863_wh7rmh.png',
    address: {
      street: 'Ellsworth Summit',
      suite: 'Suite 729',
      city: 'Aliyaview',
      zipcode: '45169',
      geo: {
        lat: '-14.3990',
        lng: '-120.7677',
      },
    },
    phone: '586.493.6943',
    website: 'jacynthe.com',
    salary: 268,
    company: {
      name: 'Abernathy Group',
      catchPhrase: 'Implemented secondary concept',
      bs: 'e-enable extensible e-tailers',
    },
  },
  {
    id: 9,
    name: 'Jaid Bin Hashem',
    username: 'Delphine',
    email: 'Dermott@dana.io',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765158283_filqfo.png',
    address: {
      street: 'Dayna Park',
      suite: 'Suite 449',
      city: 'Bartholomebury',
      zipcode: '76495-3109',
      geo: {
        lat: '24.6463',
        lng: '-168.8889',
      },
    },
    phone: '(775)976-6794',
    website: 'conrad.com',
    salary: 185,
    company: {
      name: 'Yost and Sons',
      catchPhrase: 'Switchable contextually-based project',
      bs: 'aggregate real-time technologies',
    },
  },
  {
    id: 10,
    name: 'Tanvir Islam',
    username: 'Moriah.Stanton',
    email: 'Paderg@karina.biz',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439176/hero-user/1612625248608_ndw2x2.png',
    address: {
      street: 'Kattie Turnpike',
      suite: 'Suite 198',
      city: 'Lebsackbury',
      zipcode: '31428-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '024-648-3804',
    website: 'ambrose.net',
    salary: 895,
    company: {
      name: 'Hoeger LLC',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
  {
    id: 11,
    name: 'Solaiman Shadin',
    username: 'Solaiman.Shadin',
    email: 'shadin@karina.biz',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604765214072_zl4lbo.png',
    address: {
      street: 'Kustina para',
      suite: 'Dkiite 198',
      city: 'Derkbury',
      zipcode: '8928-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '017-648-3804',
    website: 'shadin.net',
    salary: 889,
    company: {
      name: 'Programming Hero',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
  {
    id: 12,
    name: 'Mujahidul Islam',
    username: 'mujahidulislam',
    email: 'mujahid@gmail.com',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439172/hero-user/1604765123732_m340j6.png',
    address: {
      street: 'Mujahid para',
      suite: 'Njahid 198',
      city: 'Dhaka',
      zipcode: '8928-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '017-648-3804',
    website: 'mujahid.com',
    salary: 569,
    company: {
      name: 'Programming Hero',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
  {
    id: 13,
    name: 'Sadia Sultana Kumu',
    username: 'sadiakumu',
    email: 'kumu@gmail.com',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604769335985_vw5rc9.png',
    address: {
      street: 'Sadia Para',
      suite: 'Kumu 198',
      city: 'Dhaka',
      zipcode: '8958-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '018-648-3804',
    website: 'kumusadia.com',
    salary: 569,
    company: {
      name: 'Programming Hero',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
  {
    id: 14,
    name: 'Manik Roy',
    username: 'manikroy',
    email: 'manik@gmail.com',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439175/hero-user/1608733190243_shtt0h.png',
    address: {
      street: 'Manikroy Para',
      suite: 'Manikroy 198',
      city: 'Manikroy',
      zipcode: '8958-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '018-648-3804',
    website: 'manikroy.com',
    salary: 258,
    company: {
      name: 'Programming Hero',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
  {
    id: 15,
    name: 'Shrikanta Mazumder',
    username: 'srikanta',
    email: 'srikata@gmail.com',
    avatar: 'https://res.cloudinary.com/monirh/image/upload/v1614439173/hero-user/1604769396177_xkgq8q.png',
    address: {
      street: 'srikanta Para',
      suite: 'srikanta 198',
      city: 'Dhaka',
      zipcode: '8958-2261',
      geo: {
        lat: '-38.2386',
        lng: '57.2232',
      },
    },
    phone: '018-648-3804',
    website: 'srikanta.com',
    salary: 569,
    company: {
      name: 'Programming Hero',
      catchPhrase: 'Centralized empowering task-force',
      bs: 'target end-to-end models',
    },
  },
];
